import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "contactme",
  class: "container mx-auto px-4 py-4"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2" }
const _hoisted_3 = { class: "flex gap-x-4 sm:col-span-2" }
const _hoisted_4 = { class: "inline-flex items-center cursor-pointer" }
const _hoisted_5 = { class: "mt-10" }
const _hoisted_6 = ["disabled"]

import { ref } from "vue";
import emailjs from "@emailjs/browser";

/**
 * Reactive State
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactMeView',
  setup(__props) {

/**
 * Imports and Dependencies
 */
const isSubmitting = ref(false); // Tracks form submission state
const privacyAccepted = ref(false); // Tracks privacy policy acceptance

/**
 * Handles the form submission and email sending process
 * @param {Event} e - The form submission event
 */
const sendEmail = async (e: Event) => {
  // Validate privacy policy acceptance
  if (!privacyAccepted.value) {
    alert("Please accept the privacy policy to proceed.");
    return;
  }

  try {
    isSubmitting.value = true;
    const form = e.target as HTMLFormElement;

    // Prepare email template parameters
    const templateParams = {
      full_name: form["full-name"].value,
      from_email: form["email"].value,
      company_name: form["company"].value,
      phone: form["phone-number"].value,
      message: form["message"].value,
      to_email: "w.k.d.kavishka@outlook.com",
    };

    // Initialize EmailJS with public key
    emailjs.init("qz_99WqAXBiP0MXqJ");

    // Send email using EmailJS service
    await emailjs.send(
      "service_y9ix33i",
      "template_e1c3rv8",
      templateParams,
      "qz_99WqAXBiP0MXqJ"
    );

    // Handle successful submission
    alert("Message sent successfully!");
    form.reset();
    privacyAccepted.value = false;
  } catch (error) {
    // Handle errors
    console.error("Error sending email:", error);
    alert("Failed to send message. Please try again later.");
  } finally {
    isSubmitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mx-auto max-w-2xl text-center" }, [
      _createElementVNode("h2", { class: "text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-100 sm:text-4xl" }, " Contact Me "),
      _createElementVNode("p", { class: "mt-2 text-lg leading-8 text-gray-600 dark:text-slate-300" }, " Feel free to reach out to me for any inquiries or collaboration opportunities. ")
    ], -1)),
    _createElementVNode("form", {
      class: "mx-auto mt-16 max-w-xl sm:mt-20",
      method: "POST",
      onSubmit: _withModifiers(sendEmail, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"sm:col-span-2\"><label class=\"text-sm font-bold tracking-tight text-gray-900 dark:text-slate-100 sm:text-4xl\" for=\"full-name\"> Full Name </label><div class=\"mt-2.5\"><input id=\"full-name\" name=\"full-name\" type=\"text\" autocomplete=\"name\" placeholder=\"Your full name\" class=\"block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 dark:text-gray-200 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-4 focus:ring-inset focus:ring-teal-800 sm:text-sm sm:leading-6 dark:bg-custom-mid-dark\"></div></div><div class=\"sm:col-span-2\"><label class=\"text-sm font-bold tracking-tight text-gray-900 dark:text-slate-100 sm:text-4xl\" for=\"company\"> Company </label><div class=\"mt-2.5\"><input id=\"company\" autocomplete=\"organization\" class=\"block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 dark:text-gray-200 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 dark:bg-custom-mid-dark\" name=\"company\" placeholder=\"Your company name\" type=\"text\"></div></div><div class=\"sm:col-span-2\"><label class=\"text-sm font-bold tracking-tight text-gray-900 dark:text-slate-100 sm:text-4xl\" for=\"email\"> Email </label><div class=\"mt-2.5\"><input id=\"email\" autocomplete=\"email\" class=\"block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 dark:text-gray-200 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 dark:bg-custom-mid-dark\" name=\"email\" placeholder=\"you@example.com\" type=\"email\"></div></div><div class=\"sm:col-span-2\"><label class=\"text-sm font-bold tracking-tight text-gray-900 dark:text-slate-100 sm:text-4xl\" for=\"phone-number\"> Phone number </label><div class=\"mt-2.5\"><input id=\"phone-number\" autocomplete=\"tel\" class=\"block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 dark:text-gray-200 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 dark:bg-custom-mid-dark\" name=\"phone-number\" placeholder=\"+1 (555) 000-0000\" type=\"tel\"></div></div><div class=\"sm:col-span-2\"><label class=\"text-sm font-bold tracking-tight text-gray-900 dark:text-slate-100 sm:text-4xl\" for=\"message\"> Message </label><div class=\"mt-2.5\"><textarea id=\"message\" class=\"block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 dark:text-gray-200 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 dark:bg-custom-mid-dark\" name=\"message\" placeholder=\"Tell us about your project, requirements, or any questions you have...\" rows=\"4\"></textarea></div></div>", 5)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((privacyAccepted).value = $event)),
              type: "checkbox",
              class: "sr-only peer"
            }, null, 512), [
              [_vModelCheckbox, privacyAccepted.value]
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 dark:peer-focus:ring-indigo-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600 peer-checked:bg-indigo-600" }, null, -1)),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ms-3 text-sm leading-6 tracking-tight text-gray-900 dark:text-slate-100" }, [
              _createTextVNode(" By selecting this, you agree to our "),
              _createElementVNode("a", {
                class: "font-semibold text-indigo-600",
                href: "#"
              }, "privacy policy"),
              _createTextVNode(". ")
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "block w-full rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
          type: "submit",
          disabled: isSubmitting.value
        }, " Let's talk ", 8, _hoisted_6)
      ])
    ], 32)
  ]))
}
}

})